import { CustomerAddress } from '../types/customerForm'

export const isShippingAddressIncluded = (shippingAddress: CustomerAddress | undefined): boolean => {
  if (!shippingAddress) {
    return false
  }

  return Object.values(shippingAddress).some((value) => !!value)
}
